import { render, staticRenderFns } from "./categoriasComponent.vue?vue&type=template&id=47b88f11&scoped=true&"
import script from "./categoriasComponent.vue?vue&type=script&lang=js&"
export * from "./categoriasComponent.vue?vue&type=script&lang=js&"
import style0 from "./categoriasComponent.vue?vue&type=style&index=0&id=47b88f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b88f11",
  null
  
)

export default component.exports